import { useScreenOrientation } from "./useScreenOrientation";
import { useAtom } from "jotai";
import useDeviceType from "./useDeviceType";
import { globalFullscreenAtom } from "../../src/atoms";
import { useResponsive } from "./useResponsive";

export const useShowTabAd = () => {
  const [isGlobalFullScreen] = useAtom(globalFullscreenAtom);
  const { deviceType } = useDeviceType();
  const { isMediumAndDown } = useResponsive();
  const { orientation } = useScreenOrientation();

  const isTablet = deviceType === "TABLET";

  //only show tab ads if tablet is in portrait mode
  const isPortraitOnTablet = isTablet && !orientation.includes("LANDSCAPE");

  // do not use useResponsive logic  on tablets, the values are inconsistent when the orientation changes
  const passesBreakpoint = !isTablet && isMediumAndDown;

  const shouldShowTabAd =
    !isGlobalFullScreen && (isPortraitOnTablet || passesBreakpoint);

  return { shouldShowTabAd };
};
